
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import { blobToURL, urlToBlob, fromBlob, fromURL } from 'image-resize-compress';
import DeleteIcon from '@mui/icons-material/Delete';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Switch from '@mui/material/Switch';
import { useState } from 'react';
import { Button } from 'react-admin';
import { useDropzone } from 'react-dropzone';
import { useFileManagerModalInputDialogContentContext } from './FileManagerModalInputDialogContentProvider';
import FileManagerModalInputDialogUploadCreateFolder from './FileManagerModalInputDialogUploadCreateFolder';

interface FileManagerModalInputDialogUploadProps {
}
const FileManagerModalInputDialogUpload = ({ ...props }: FileManagerModalInputDialogUploadProps) => {
  const { group, sub, reload } = useFileManagerModalInputDialogContentContext();
  const [enableCompress, setEnableCompress] = useState(true);
  const [list, setList] = useState<Array<File>>([]);
  const onDrop = (acceptedFiles: Array<File>) => {
    // Do something with the files
    let newFiles = acceptedFiles.filter((af: File) => -1 === list.findIndex(listF => listF.name === af.name))
    // console.log(acceptedFiles, newFiles, list);
    setList(o => [...o, ...newFiles]);
    if (acceptedFiles.length !== newFiles.length) {

    }
  }

  const handleUploadClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    Promise.all(list.map(f => enableCompress ? fromBlob(f, 90, 'auto', 'auto').then((myBlob: Blob) => new File([myBlob], f.name)) : f)).then((list) => {
      const formData = new FormData();
      list.forEach(file => {
        formData.append('files[]', file, file.name);
      })
      fetch(`/api/file-system/upload/${group}?sub=${sub.join('/')}`, { method: 'POST', body: formData }).then(() => {
        reload();
        setList([]);
      });
    })
  }
  const handleDeleteClick = (e: any, index: number) => {
    e.preventDefault();
    e.stopPropagation();
    setList(o => {
      o.splice(index, 1);
      return [...o];
    })
  }
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <>
      <FileManagerModalInputDialogUploadCreateFolder />
      <Paper {...getRootProps()} sx={{ width: "calc(100% - 8px)", height: 'calc(90vh - 64px - 64px - 64px)', }}>
        <input {...getInputProps()} />

        <Box style={{ background: 'lightgray', minHeight: '64px' }}>
          {isDragActive ? <span>Drop the files here ...</span> : <span>Drag 'n' drop here or Click</span>}
        </Box>

        <FormGroup>
          <FormControlLabel control={<Switch value={enableCompress} defaultChecked onClick={(e) => { e.stopPropagation(); }} onChange={() => setEnableCompress((o) => !o)} />} label="Enable Compression" />
        </FormGroup>
        <Button variant="outlined" label="Upload" onClick={(e) => handleUploadClick(e)}><FileUploadIcon /></Button>

        <ul style={{ overflowY: 'scroll', height: 'calc(100% - 64px - 48px)' }}>
          {list.map((f, i) =>
            <li key={`${i}-${f.name}`}>
              {f.name}
              <IconButton edge="end" aria-label="delete" onClick={(e) => handleDeleteClick(e, i)}><DeleteIcon /></IconButton>
            </li>
          )}
        </ul>
      </Paper>
    </>
  )
}

export default FileManagerModalInputDialogUpload;
